import ReactEcharts from "echarts-for-react";
// Use the package name directly, not the path to the min.js
import 'echarts-wordcloud';
import React, { useEffect, useMemo, useState } from "react";
import "../../../node_modules/echarts-wordcloud/dist/echarts-wordcloud.min.js";
import { useLocalStorageNew } from "../../hooks/useLocalStorageNew.js";
import { ReactComponent as NoResultIllustration } from "../../images/no_result.svg";
import {
    EMPTY_WORD_CLOUD_TEXT,
    // QUESTION_IMAGE_ID,
    // WORD_CLOUD_COLORS,
    WORD_CLOUD_DATA,
    WORD_CLOUD_ID
} from "../../utils/constants";
import {
    autoFontSize,
    // autoFontColor,
    // autoFontSize,
    // getWordCloudWidth,
    organiseData
} from "../../utils/helpers.js";
import "./styles.css";


// import "tippy.js/dist/tippy.css";
// import "tippy.js/animations/scale.css";
// import "../../utils/echarts-wordcloud.min.js";

export default function WordCloudResult({
    data,
    serialNo=1,
    correctAnswers=[],
    customStyle=null, 
    isSwitching=false,
    setIsSWitching=null, 
}) {
    // ReactWordCloud (d3):
    // const callbacks = {
    //     getWordColor: word => word.value > 50 ? "blue" : "red",
    //     onWordClick: console.log,
    //     onWordMouseOver: console.log,
    //     getWordTooltip: word => `${word.text} (${word.value}) [${word.value > 50 ? "good" : "bad"}]`,
    //   }
    //   const options = {
    //     colors: ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b"],
    //     enableTooltip: true,
    //     deterministic: true,
    //     fontFamily: "Geomanist",
    //     fontSizes: [5, 60],
    //     fontStyle: "normal",
    //     fontWeight: "normal",
    //     padding: 1,
    //     rotations: 2,
    //     rotationAngles: [-90, 0, 90],
    //     // scale: "sqrt",
    //     // spiral: "archimedean",
    //     transitionDuration: 500
    //   };
    //   const size = [900, 400];
    
    // const rawStr = `Declarative visualization grammars can accelerate development, facilitate retargeting across platforms, and allow language-level optimizations. However, existing declarative visualization languages are primarily concerned with visual encoding, and rely on imperative event handlers for interactive behaviors. In response, we introduce a model of declarative interaction design for data visualizations. Adopting methods from reactive programming, we model low-level events as composable data streams from which we form higher-level semantic signals. Signals feed predicates and scale inversions, which allow us to generalize interactive selections at the level of item geometry (pixels) into interactive queries over the data domain. Production rules then use these queries to manipulate the visualization’s appearance. To facilitate reuse and sharing, these constructs can be encapsulated as named interactors: standalone, purely declarative specifications of interaction techniques. We assess our model’s feasibility and expressivity by instantiating it with extensions to the Vega visualization grammar. Through a diverse range of examples, we demonstrate coverage over an established taxonomy of visualization interaction techniques. We present Reactive Vega, a system architecture that provides the first robust and comprehensive treatment of declarative visual and interaction design for data visualization. Starting from a single declarative specification, Reactive Vega constructs a dataflow graph in which input data, scene graph elements, and interaction events are all treated as first-class streaming data sources. To support expressive interactive visualizations that may involve time-varying scalar, relational, or hierarchical data, Reactive Vega’s dataflow graph can dynamically re-write itself at runtime by extending or pruning branches in a data-driven fashion. We discuss both compile- and run-time optimizations applied within Reactive Vega, and share the results of benchmark studies that indicate superior interactive performance to both D3 and the original, non-reactive Vega system. We present Vega-Lite, a high-level grammar that enables rapid specification of interactive data visualizations. Vega-Lite combines a traditional grammar of graphics, providing visual encoding rules and a composition algebra for layered and multi-view displays, with a novel grammar of interaction. Users specify interactive semantics by composing selections. In Vega-Lite, a selection is an abstraction that defines input event processing, points of interest, and a predicate function for inclusion testing. Selections parameterize visual encodings by serving as input data, defining scale extents, or by driving conditional logic. The Vega-Lite compiler automatically synthesizes requisite data flow and event handling logic, which users can override for further customization. In contrast to existing reactive specifications, Vega-Lite selections decompose an interaction design into concise, enumerable semantic units. We evaluate Vega-Lite through a range of examples, demonstrating succinct specification of both customized interaction methods and common techniques such as panning, zooming, and linked selection.`;
    const [option, setOption] = useState({});
    const [setLocalData, getLocalData] = useLocalStorageNew(WORD_CLOUD_DATA, {});
    const chart = useMemo(() => {
        return (
            <ReactEcharts
                option={option}
                notMerge={false}
                lazyUpdate={false}
                // theme={"theme_name"}
                // onChartReady={this.onChartReadyCallback}
                // onEvents={EventsDict}
                // opts={}
                style={{
                    width: '100%',
                    height: customStyle ? customStyle.height : '300px',
                }}
            />
        );
    }, [option]);

    useEffect(() => {
        setLocalData({});
    }, []);

    useEffect(() => {
        // console.log(data, getLocalData()[serialNo], JSON.stringify(data) === JSON.stringify(getLocalData()[serialNo]));
        if (!data) return;
        if (JSON.stringify(data) === JSON.stringify(getLocalData()[serialNo]) && !isSwitching) return; // prevent rerender
        // console.log(data);
        if (setIsSWitching) {
            setIsSWitching(false);
        }
        let localData = {...getLocalData()};
        localData[serialNo] = data;
        setLocalData(localData);

        setOption({
            // responsive: true,
            // grid: {
            //     width: '100%',
            //     height: '450px',
            //     left: 0,
            //     right: 0,
            //     top: 0,
            //     bottom: 0
            // },
            title: {
                show: data.length === 0,
                textStyle: {
                    color: "grey",
                    fontSize: 20, 
                    lineHeight: 1.4,
                },
                text: EMPTY_WORD_CLOUD_TEXT,
                left: "center",
                top: "center"
            },
            tooltip: {
                show: customStyle ? customStyle.tooltip : true,
                confine: true,
                extraCssText: 'width: auto; white-space: pre-wrap;',
                // formatter: (params) => {
                //     console.log(params);
                //     return `${params.name}${correctAnswers.includes(params.name) ? '(correct)' : ''}: ${params.value}`;
                // }
            },
            series: [{
                type: 'wordCloud',
                gridSize: autoFontSize(serialNo),
                sizeRange: [autoFontSize(serialNo), autoFontSize(serialNo)*3],
                rotationRange: [0, 0],
                // rotationStep: 90,
                // shape: 'square',
                keepAspect: false,
                // responsive: true,
                // width: getWordCloudWidth(),
                // width: '100%',
                // height: '450px',
                drawOutOfBound: false,
                shrinkToFit: true,
                // universalAnimation: true,
                layoutAnimation: true,
                animation: true,
                animationThreshold: 2000,
                animationDuration: 1000,
                animationEasing: 'cubicOut',
                animationDelay: 0,
                animationDurationUpdate: 300,
                animationEasingUpdate: 'cubicInOut',
                animationDelayUpdate: 0,
                // textStyle: {
                    // fontSize: autoFontSize(),
                    // color: () => { // to pick random color
                    //     return WORD_CLOUD_COLORS[Math.floor(Math.random() * WORD_CLOUD_COLORS.length)];
                    // }
                // },
                emphasis: {
                    focus: 'self',
                    textStyle: {
                        shadowBlur: 10,
                        // shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                },
                data: organiseData(data, correctAnswers) // pass correctAns for Graded Poll
            }],
            layoutAnimation: true,
            animation: true,
            animationThreshold: 2000,
            animationDuration: 1000,
            animationEasing: 'cubicOut',
            animationDelay: 0,
            animationDurationUpdate: 300,
            animationEasingUpdate: 'cubicInOut',
            animationDelayUpdate: 0,
        });
    }, [data]);

    return (
        <>
            {!!data && data.length > 0 &&
                <div
                    // key={WORD_CLOUD_ID + serialNo}
                    id={WORD_CLOUD_ID + serialNo}
                    className="word-cloud-wrapper"
                    style={data && data.length === 0 ? {visibility: "hidden", height: "0px"} : {}}
                >
                    {chart}
                </div>
            }

            {(!data || data.length === 0) &&
                <div style={{
                    width: "100%",
                    height: 210,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 15
                }}>
                    <span style={{flex: 1}}/>
                    <NoResultIllustration width={240} height={125} style={{flexShrink: 0}}/>
                    <div style={{fontSize: 16, fontWeight: 600}}>
                        {EMPTY_WORD_CLOUD_TEXT}
                    </div>
                    <span style={{flex: 1}}/>
                </div>
            }
        </>
    );
};